/*!
 * Masonry PACKAGED v3.2.2
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

/**
 * Bridget makes jQuery widgets
 * v1.1.0
 * MIT license
 */

( function( window ) {



// -------------------------- utils -------------------------- //

    var slice = Array.prototype.slice;

    function noop() {}

// -------------------------- definition -------------------------- //

    function defineBridget( $ ) {

// bail if no jQuery
        if ( !$ ) {
            return;
        }

// -------------------------- addOptionMethod -------------------------- //

        /**
         * adds option method -> $().plugin('option', {...})
         * @param {Function} PluginClass - constructor class
         */
        function addOptionMethod( PluginClass ) {
            // don't overwrite original option method
            if ( PluginClass.prototype.option ) {
                return;
            }

            // option setter
            PluginClass.prototype.option = function( opts ) {
                // bail out if not an object
                if ( !$.isPlainObject( opts ) ){
                    return;
                }
                this.options = $.extend( true, this.options, opts );
            };
        }

// -------------------------- plugin bridge -------------------------- //

// helper function for logging errors
// $.error breaks jQuery chaining
        var logError = typeof console === 'undefined' ? noop :
            function( message ) {
                console.error( message );
            };

        /**
         * jQuery plugin bridge, access methods like $elem.plugin('method')
         * @param {String} namespace - plugin name
         * @param {Function} PluginClass - constructor class
         */
        function bridge( namespace, PluginClass ) {
            // add to jQuery fn namespace
            $.fn[ namespace ] = function( options ) {
                if ( typeof options === 'string' ) {
                    // call plugin method when first argument is a string
                    // get arguments for method
                    var args = slice.call( arguments, 1 );

                    for ( var i=0, len = this.length; i < len; i++ ) {
                        var elem = this[i];
                        var instance = $.data( elem, namespace );
                        if ( !instance ) {
                            logError( "cannot call methods on " + namespace + " prior to initialization; " +
                                "attempted to call '" + options + "'" );
                            continue;
                        }
                        if ( !$.isFunction( instance[options] ) || options.charAt(0) === '_' ) {
                            logError( "no such method '" + options + "' for " + namespace + " instance" );
                            continue;
                        }

                        // trigger method with arguments
                        var returnValue = instance[ options ].apply( instance, args );

                        // break look and return first value if provided
                        if ( returnValue !== undefined ) {
                            return returnValue;
                        }
                    }
                    // return this if no return value
                    return this;
                } else {
                    return this.each( function() {
                        var instance = $.data( this, namespace );
                        if ( instance ) {
                            // apply options & init
                            instance.option( options );
                            instance._init();
                        } else {
                            // initialize new instance
                            instance = new PluginClass( this, options );
                            $.data( this, namespace, instance );
                        }
                    });
                }
            };

        }

// -------------------------- bridget -------------------------- //

        /**
         * converts a Prototypical class into a proper jQuery plugin
         *   the class must have a ._init method
         * @param {String} namespace - plugin name, used in $().pluginName
         * @param {Function} PluginClass - constructor class
         */
        $.bridget = function( namespace, PluginClass ) {
            addOptionMethod( PluginClass );
            bridge( namespace, PluginClass );
        };

        return $.bridget;

    }

// transport
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'jquery-bridget/jquery.bridget',[ 'jquery' ], defineBridget );
    } else if ( typeof exports === 'object' ) {
        defineBridget( require('jquery') );
    } else {
        // get jquery from browser global
        defineBridget( window.jQuery );
    }

})( window );

/*!
 * eventie v1.0.5
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {



    var docElem = document.documentElement;

    var bind = function() {};

    function getIEEvent( obj ) {
        var event = window.event;
        // add event.target
        event.target = event.target || event.srcElement || obj;
        return event;
    }

    if ( docElem.addEventListener ) {
        bind = function( obj, type, fn ) {
            obj.addEventListener( type, fn, false );
        };
    } else if ( docElem.attachEvent ) {
        bind = function( obj, type, fn ) {
            obj[ type + fn ] = fn.handleEvent ?
                function() {
                    var event = getIEEvent( obj );
                    fn.handleEvent.call( fn, event );
                } :
                function() {
                    var event = getIEEvent( obj );
                    fn.call( obj, event );
                };
            obj.attachEvent( "on" + type, obj[ type + fn ] );
        };
    }

    var unbind = function() {};

    if ( docElem.removeEventListener ) {
        unbind = function( obj, type, fn ) {
            obj.removeEventListener( type, fn, false );
        };
    } else if ( docElem.detachEvent ) {
        unbind = function( obj, type, fn ) {
            obj.detachEvent( "on" + type, obj[ type + fn ] );
            try {
                delete obj[ type + fn ];
            } catch ( err ) {
                // can't delete window object properties
                obj[ type + fn ] = undefined;
            }
        };
    }

    var eventie = {
        bind: bind,
        unbind: unbind
    };

// ----- module definition ----- //

    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'eventie/eventie',eventie );
    } else if ( typeof exports === 'object' ) {
        // CommonJS
        module.exports = eventie;
    } else {
        // browser global
        window.eventie = eventie;
    }

})( this );

/*!
 * docReady v1.0.4
 * Cross browser DOMContentLoaded event emitter
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true*/
/*global define: false, require: false, module: false */

( function( window ) {



    var document = window.document;
// collection of functions to be triggered on ready
    var queue = [];

    function docReady( fn ) {
        // throw out non-functions
        if ( typeof fn !== 'function' ) {
            return;
        }

        if ( docReady.isReady ) {
            // ready now, hit it
            fn();
        } else {
            // queue function when ready
            queue.push( fn );
        }
    }

    docReady.isReady = false;

// triggered on various doc ready events
    function onReady( event ) {
        // bail if already triggered or IE8 document is not ready just yet
        var isIE8NotReady = event.type === 'readystatechange' && document.readyState !== 'complete';
        if ( docReady.isReady || isIE8NotReady ) {
            return;
        }

        trigger();
    }

    function trigger() {
        docReady.isReady = true;
        // process queue
        for ( var i=0, len = queue.length; i < len; i++ ) {
            var fn = queue[i];
            fn();
        }
    }

    function defineDocReady( eventie ) {
        // trigger ready if page is ready
        if ( document.readyState === 'complete' ) {
            trigger();
        } else {
            // listen for events
            eventie.bind( document, 'DOMContentLoaded', onReady );
            eventie.bind( document, 'readystatechange', onReady );
            eventie.bind( window, 'load', onReady );
        }

        return docReady;
    }

// transport
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'doc-ready/doc-ready',[ 'eventie/eventie' ], defineDocReady );
    } else if ( typeof exports === 'object' ) {
        module.exports = defineDocReady( require('eventie') );
    } else {
        // browser global
        window.docReady = defineDocReady( window.eventie );
    }

})( window );

/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {


    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listeners = this.getListenersAsObject(evt);
        var listener;
        var i;
        var key;
        var response;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                i = listeners[key].length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[key][i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define('eventEmitter/EventEmitter',[],function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

/*!
 * getStyleProperty v1.0.4
 * original by kangax
 * http://perfectionkills.com/feature-testing-css-properties/
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true */
/*global define: false, exports: false, module: false */

( function( window ) {



    var prefixes = 'Webkit Moz ms Ms O'.split(' ');
    var docElemStyle = document.documentElement.style;

    function getStyleProperty( propName ) {
        if ( !propName ) {
            return;
        }

        // test standard property first
        if ( typeof docElemStyle[ propName ] === 'string' ) {
            return propName;
        }

        // capitalize
        propName = propName.charAt(0).toUpperCase() + propName.slice(1);

        // test vendor specific properties
        var prefixed;
        for ( var i=0, len = prefixes.length; i < len; i++ ) {
            prefixed = prefixes[i] + propName;
            if ( typeof docElemStyle[ prefixed ] === 'string' ) {
                return prefixed;
            }
        }
    }

// transport
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'get-style-property/get-style-property',[],function() {
            return getStyleProperty;
        });
    } else if ( typeof exports === 'object' ) {
        // CommonJS for Component
        module.exports = getStyleProperty;
    } else {
        // browser global
        window.getStyleProperty = getStyleProperty;
    }

})( window );

/*!
 * getSize v1.2.2
 * measure size of elements
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, exports: false, require: false, module: false, console: false */

( function( window, undefined ) {



// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
    function getStyleSize( value ) {
        var num = parseFloat( value );
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') === -1 && !isNaN( num );
        return isValid && num;
    }

    function noop() {}

    var logError = typeof console === 'undefined' ? noop :
        function( message ) {
            console.error( message );
        };

// -------------------------- measurements -------------------------- //

    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];

    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for ( var i=0, len = measurements.length; i < len; i++ ) {
            var measurement = measurements[i];
            size[ measurement ] = 0;
        }
        return size;
    }



    function defineGetSize( getStyleProperty ) {

// -------------------------- setup -------------------------- //

        var isSetup = false;

        var getStyle, boxSizingProp, isBoxSizeOuter;

        /**
         * setup vars and functions
         * do it on initial getSize(), rather than on script load
         * For Firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=548397
         */
        function setup() {
            // setup once
            if ( isSetup ) {
                return;
            }
            isSetup = true;

            var getComputedStyle = window.getComputedStyle;
            getStyle = ( function() {
                var getStyleFn = getComputedStyle ?
                    function( elem ) {
                        return getComputedStyle( elem, null );
                    } :
                    function( elem ) {
                        return elem.currentStyle;
                    };

                return function getStyle( elem ) {
                    var style = getStyleFn( elem );
                    if ( !style ) {
                        logError( 'Style returned ' + style +
                            '. Are you running this code in a hidden iframe on Firefox? ' +
                            'See http://bit.ly/getsizebug1' );
                    }
                    return style;
                };
            })();

            // -------------------------- box sizing -------------------------- //

            boxSizingProp = getStyleProperty('boxSizing');

            /**
             * WebKit measures the outer-width on style.width on border-box elems
             * IE & Firefox measures the inner-width
             */
            if ( boxSizingProp ) {
                var div = document.createElement('div');
                div.style.width = '200px';
                div.style.padding = '1px 2px 3px 4px';
                div.style.borderStyle = 'solid';
                div.style.borderWidth = '1px 2px 3px 4px';
                div.style[ boxSizingProp ] = 'border-box';

                var body = document.body || document.documentElement;
                body.appendChild( div );
                var style = getStyle( div );

                isBoxSizeOuter = getStyleSize( style.width ) === 200;
                body.removeChild( div );
            }

        }

// -------------------------- getSize -------------------------- //

        function getSize( elem ) {
            setup();

            // use querySeletor if elem is string
            if ( typeof elem === 'string' ) {
                elem = document.querySelector( elem );
            }

            // do not proceed on non-objects
            if ( !elem || typeof elem !== 'object' || !elem.nodeType ) {
                return;
            }

            var style = getStyle( elem );

            // if hidden, everything is 0
            if ( style.display === 'none' ) {
                return getZeroSize();
            }

            var size = {};
            size.width = elem.offsetWidth;
            size.height = elem.offsetHeight;

            var isBorderBox = size.isBorderBox = !!( boxSizingProp &&
                style[ boxSizingProp ] && style[ boxSizingProp ] === 'border-box' );

            // get all measurements
            for ( var i=0, len = measurements.length; i < len; i++ ) {
                var measurement = measurements[i];
                var value = style[ measurement ];
                value = mungeNonPixel( elem, value );
                var num = parseFloat( value );
                // any 'auto', 'medium' value will be 0
                size[ measurement ] = !isNaN( num ) ? num : 0;
            }

            var paddingWidth = size.paddingLeft + size.paddingRight;
            var paddingHeight = size.paddingTop + size.paddingBottom;
            var marginWidth = size.marginLeft + size.marginRight;
            var marginHeight = size.marginTop + size.marginBottom;
            var borderWidth = size.borderLeftWidth + size.borderRightWidth;
            var borderHeight = size.borderTopWidth + size.borderBottomWidth;

            var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

            // overwrite width and height if we can get it from style
            var styleWidth = getStyleSize( style.width );
            if ( styleWidth !== false ) {
                size.width = styleWidth +
                    // add padding and border unless it's already including it
                    ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
            }

            var styleHeight = getStyleSize( style.height );
            if ( styleHeight !== false ) {
                size.height = styleHeight +
                    // add padding and border unless it's already including it
                    ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
            }

            size.innerWidth = size.width - ( paddingWidth + borderWidth );
            size.innerHeight = size.height - ( paddingHeight + borderHeight );

            size.outerWidth = size.width + marginWidth;
            size.outerHeight = size.height + marginHeight;

            return size;
        }

// IE8 returns percent values, not pixels
// taken from jQuery's curCSS
        function mungeNonPixel( elem, value ) {
            // IE8 and has percent value
            if ( window.getComputedStyle || value.indexOf('%') === -1 ) {
                return value;
            }
            var style = elem.style;
            // Remember the original values
            var left = style.left;
            var rs = elem.runtimeStyle;
            var rsLeft = rs && rs.left;

            // Put in the new values to get a computed value out
            if ( rsLeft ) {
                rs.left = elem.currentStyle.left;
            }
            style.left = value;
            value = style.pixelLeft;

            // Revert the changed values
            style.left = left;
            if ( rsLeft ) {
                rs.left = rsLeft;
            }

            return value;
        }

        return getSize;

    }

// transport
    if ( typeof define === 'function' && define.amd ) {
        // AMD for RequireJS
        define( 'get-size/get-size',[ 'get-style-property/get-style-property' ], defineGetSize );
    } else if ( typeof exports === 'object' ) {
        // CommonJS for Component
        module.exports = defineGetSize( require('desandro-get-style-property') );
    } else {
        // browser global
        window.getSize = defineGetSize( window.getStyleProperty );
    }

})( window );

/**
 * matchesSelector v1.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */
/*global define: false, module: false */

( function( ElemProto ) {



    var matchesMethod = ( function() {
        // check un-prefixed
        if ( ElemProto.matchesSelector ) {
            return 'matchesSelector';
        }
        // check vendor prefixes
        var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

        for ( var i=0, len = prefixes.length; i < len; i++ ) {
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if ( ElemProto[ method ] ) {
                return method;
            }
        }
    })();

    // ----- match ----- //

    function match( elem, selector ) {
        return elem[ matchesMethod ]( selector );
    }

    // ----- appendToFragment ----- //

    function checkParent( elem ) {
        // not needed if already has parent
        if ( elem.parentNode ) {
            return;
        }
        var fragment = document.createDocumentFragment();
        fragment.appendChild( elem );
    }

    // ----- query ----- //

    // fall back to using QSA
    // thx @jonathantneal https://gist.github.com/3062955
    function query( elem, selector ) {
        // append to fragment if no parent
        checkParent( elem );

        // match elem with all selected elems of parent
        var elems = elem.parentNode.querySelectorAll( selector );
        for ( var i=0, len = elems.length; i < len; i++ ) {
            // return true if match
            if ( elems[i] === elem ) {
                return true;
            }
        }
        // otherwise return false
        return false;
    }

    // ----- matchChild ----- //

    function matchChild( elem, selector ) {
        checkParent( elem );
        return match( elem, selector );
    }

    // ----- matchesSelector ----- //

    var matchesSelector;

    if ( matchesMethod ) {
        // IE9 supports matchesSelector, but doesn't work on orphaned elems
        // check for that
        var div = document.createElement('div');
        var supportsOrphans = match( div, 'div' );
        matchesSelector = supportsOrphans ? match : matchChild;
    } else {
        matchesSelector = query;
    }

    // transport
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'matches-selector/matches-selector',[],function() {
            return matchesSelector;
        });
    } else if ( typeof exports === 'object' ) {
        module.exports = matchesSelector;
    }
    else {
        // browser global
        window.matchesSelector = matchesSelector;
    }

})( Element.prototype );

/**
 * Outlayer Item
 */

( function( window ) {



// ----- get style ----- //

    var getComputedStyle = window.getComputedStyle;
    var getStyle = getComputedStyle ?
        function( elem ) {
            return getComputedStyle( elem, null );
        } :
        function( elem ) {
            return elem.currentStyle;
        };


// extend objects
    function extend( a, b ) {
        for ( var prop in b ) {
            a[ prop ] = b[ prop ];
        }
        return a;
    }

    function isEmptyObj( obj ) {
        for ( var prop in obj ) {
            return false;
        }
        prop = null;
        return true;
    }

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    function toDash( str ) {
        return str.replace( /([A-Z])/g, function( $1 ){
            return '-' + $1.toLowerCase();
        });
    }

// -------------------------- Outlayer definition -------------------------- //

    function outlayerItemDefinition( EventEmitter, getSize, getStyleProperty ) {

// -------------------------- CSS3 support -------------------------- //

        var transitionProperty = getStyleProperty('transition');
        var transformProperty = getStyleProperty('transform');
        var supportsCSS3 = transitionProperty && transformProperty;
        var is3d = !!getStyleProperty('perspective');

        var transitionEndEvent = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'otransitionend',
            transition: 'transitionend'
        }[ transitionProperty ];

// properties that could have vendor prefix
        var prefixableProperties = [
            'transform',
            'transition',
            'transitionDuration',
            'transitionProperty'
        ];

// cache all vendor properties
        var vendorProperties = ( function() {
            var cache = {};
            for ( var i=0, len = prefixableProperties.length; i < len; i++ ) {
                var prop = prefixableProperties[i];
                var supportedProp = getStyleProperty( prop );
                if ( supportedProp && supportedProp !== prop ) {
                    cache[ prop ] = supportedProp;
                }
            }
            return cache;
        })();

// -------------------------- Item -------------------------- //

        function Item( element, layout ) {
            if ( !element ) {
                return;
            }

            this.element = element;
            // parent layout class, i.e. Masonry, Isotope, or Packery
            this.layout = layout;
            this.position = {
                x: 0,
                y: 0
            };

            this._create();
        }

// inherit EventEmitter
        extend( Item.prototype, EventEmitter.prototype );

        Item.prototype._create = function() {
            // transition objects
            this._transn = {
                ingProperties: {},
                clean: {},
                onEnd: {}
            };

            this.css({
                position: 'absolute'
            });
        };

// trigger specified handler for event type
        Item.prototype.handleEvent = function( event ) {
            var method = 'on' + event.type;
            if ( this[ method ] ) {
                this[ method ]( event );
            }
        };

        Item.prototype.getSize = function() {
            this.size = getSize( this.element );
        };

        /**
         * apply CSS styles to element
         * @param {Object} style
         */
        Item.prototype.css = function( style ) {
            var elemStyle = this.element.style;

            for ( var prop in style ) {
                // use vendor property if available
                var supportedProp = vendorProperties[ prop ] || prop;
                elemStyle[ supportedProp ] = style[ prop ];
            }
        };

        // measure position, and sets it
        Item.prototype.getPosition = function() {
            var style = getStyle( this.element );
            var layoutOptions = this.layout.options;
            var isOriginLeft = layoutOptions.isOriginLeft;
            var isOriginTop = layoutOptions.isOriginTop;
            var x = parseInt( style[ isOriginLeft ? 'left' : 'right' ], 10 );
            var y = parseInt( style[ isOriginTop ? 'top' : 'bottom' ], 10 );

            // clean up 'auto' or other non-integer values
            x = isNaN( x ) ? 0 : x;
            y = isNaN( y ) ? 0 : y;
            // remove padding from measurement
            var layoutSize = this.layout.size;
            x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
            y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

            this.position.x = x;
            this.position.y = y;
        };

// set settled position, apply padding
        Item.prototype.layoutPosition = function() {
            var layoutSize = this.layout.size;
            var layoutOptions = this.layout.options;
            var style = {};

            if ( layoutOptions.isOriginLeft ) {
                style.left = ( this.position.x + layoutSize.paddingLeft ) + 'px';
                // reset other property
                style.right = '';
            } else {
                style.right = ( this.position.x + layoutSize.paddingRight ) + 'px';
                style.left = '';
            }

            if ( layoutOptions.isOriginTop ) {
                style.top = ( this.position.y + layoutSize.paddingTop ) + 'px';
                style.bottom = '';
            } else {
                style.bottom = ( this.position.y + layoutSize.paddingBottom ) + 'px';
                style.top = '';
            }

            this.css( style );
            this.emitEvent( 'layout', [ this ] );
        };


// transform translate function
        var translate = is3d ?
            function( x, y ) {
                return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
            } :
            function( x, y ) {
                return 'translate(' + x + 'px, ' + y + 'px)';
            };


        Item.prototype._transitionTo = function( x, y ) {
            this.getPosition();
            // get current x & y from top/left
            var curX = this.position.x;
            var curY = this.position.y;

            var compareX = parseInt( x, 10 );
            var compareY = parseInt( y, 10 );
            var didNotMove = compareX === this.position.x && compareY === this.position.y;

            // save end position
            this.setPosition( x, y );

            // if did not move and not transitioning, just go to layout
            if ( didNotMove && !this.isTransitioning ) {
                this.layoutPosition();
                return;
            }

            var transX = x - curX;
            var transY = y - curY;
            var transitionStyle = {};
            // flip cooridinates if origin on right or bottom
            var layoutOptions = this.layout.options;
            transX = layoutOptions.isOriginLeft ? transX : -transX;
            transY = layoutOptions.isOriginTop ? transY : -transY;
            transitionStyle.transform = translate( transX, transY );

            this.transition({
                to: transitionStyle,
                onTransitionEnd: {
                    transform: this.layoutPosition
                },
                isCleaning: true
            });
        };

// non transition + transform support
        Item.prototype.goTo = function( x, y ) {
            this.setPosition( x, y );
            this.layoutPosition();
        };

// use transition and transforms if supported
        Item.prototype.moveTo = supportsCSS3 ?
            Item.prototype._transitionTo : Item.prototype.goTo;

        Item.prototype.setPosition = function( x, y ) {
            this.position.x = parseInt( x, 10 );
            this.position.y = parseInt( y, 10 );
        };

// ----- transition ----- //

        /**
         * @param {Object} style - CSS
         * @param {Function} onTransitionEnd
         */

// non transition, just trigger callback
        Item.prototype._nonTransition = function( args ) {
            this.css( args.to );
            if ( args.isCleaning ) {
                this._removeStyles( args.to );
            }
            for ( var prop in args.onTransitionEnd ) {
                args.onTransitionEnd[ prop ].call( this );
            }
        };

        /**
         * proper transition
         * @param {Object} args - arguments
         *   @param {Object} to - style to transition to
         *   @param {Object} from - style to start transition from
         *   @param {Boolean} isCleaning - removes transition styles after transition
         *   @param {Function} onTransitionEnd - callback
         */
        Item.prototype._transition = function( args ) {
            // redirect to nonTransition if no transition duration
            if ( !parseFloat( this.layout.options.transitionDuration ) ) {
                this._nonTransition( args );
                return;
            }

            var _transition = this._transn;
            // keep track of onTransitionEnd callback by css property
            for ( var prop in args.onTransitionEnd ) {
                _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
            }
            // keep track of properties that are transitioning
            for ( prop in args.to ) {
                _transition.ingProperties[ prop ] = true;
                // keep track of properties to clean up when transition is done
                if ( args.isCleaning ) {
                    _transition.clean[ prop ] = true;
                }
            }

            // set from styles
            if ( args.from ) {
                this.css( args.from );
                // force redraw. http://blog.alexmaccaw.com/css-transitions
                var h = this.element.offsetHeight;
                // hack for JSHint to hush about unused var
                h = null;
            }
            // enable transition
            this.enableTransition( args.to );
            // set styles that are transitioning
            this.css( args.to );

            this.isTransitioning = true;

        };

        var itemTransitionProperties = transformProperty && ( toDash( transformProperty ) +
            ',opacity' );

        Item.prototype.enableTransition = function(/* style */) {
            // only enable if not already transitioning
            // bug in IE10 were re-setting transition style will prevent
            // transitionend event from triggering
            if ( this.isTransitioning ) {
                return;
            }

            // make transition: foo, bar, baz from style object
            // TODO uncomment this bit when IE10 bug is resolved
            // var transitionValue = [];
            // for ( var prop in style ) {
            //   // dash-ify camelCased properties like WebkitTransition
            //   transitionValue.push( toDash( prop ) );
            // }
            // enable transition styles
            // HACK always enable transform,opacity for IE10
            this.css({
                transitionProperty: itemTransitionProperties,
                transitionDuration: this.layout.options.transitionDuration
            });
            // listen for transition end event
            this.element.addEventListener( transitionEndEvent, this, false );
        };

        Item.prototype.transition = Item.prototype[ transitionProperty ? '_transition' : '_nonTransition' ];

// ----- events ----- //

        Item.prototype.onwebkitTransitionEnd = function( event ) {
            this.ontransitionend( event );
        };

        Item.prototype.onotransitionend = function( event ) {
            this.ontransitionend( event );
        };

// properties that I munge to make my life easier
        var dashedVendorProperties = {
            '-webkit-transform': 'transform',
            '-moz-transform': 'transform',
            '-o-transform': 'transform'
        };

        Item.prototype.ontransitionend = function( event ) {
            // disregard bubbled events from children
            if ( event.target !== this.element ) {
                return;
            }
            var _transition = this._transn;
            // get property name of transitioned property, convert to prefix-free
            var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

            // remove property that has completed transitioning
            delete _transition.ingProperties[ propertyName ];
            // check if any properties are still transitioning
            if ( isEmptyObj( _transition.ingProperties ) ) {
                // all properties have completed transitioning
                this.disableTransition();
            }
            // clean style
            if ( propertyName in _transition.clean ) {
                // clean up style
                this.element.style[ event.propertyName ] = '';
                delete _transition.clean[ propertyName ];
            }
            // trigger onTransitionEnd callback
            if ( propertyName in _transition.onEnd ) {
                var onTransitionEnd = _transition.onEnd[ propertyName ];
                onTransitionEnd.call( this );
                delete _transition.onEnd[ propertyName ];
            }

            this.emitEvent( 'transitionEnd', [ this ] );
        };

        Item.prototype.disableTransition = function() {
            this.removeTransitionStyles();
            this.element.removeEventListener( transitionEndEvent, this, false );
            this.isTransitioning = false;
        };

        /**
         * removes style property from element
         * @param {Object} style
         **/
        Item.prototype._removeStyles = function( style ) {
            // clean up transition styles
            var cleanStyle = {};
            for ( var prop in style ) {
                cleanStyle[ prop ] = '';
            }
            this.css( cleanStyle );
        };

        var cleanTransitionStyle = {
            transitionProperty: '',
            transitionDuration: ''
        };

        Item.prototype.removeTransitionStyles = function() {
            // remove transition
            this.css( cleanTransitionStyle );
        };

// ----- show/hide/remove ----- //

// remove element from DOM
        Item.prototype.removeElem = function() {
            this.element.parentNode.removeChild( this.element );
            this.emitEvent( 'remove', [ this ] );
        };

        Item.prototype.remove = function() {
            // just remove element if no transition support or no transition
            if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
                this.removeElem();
                return;
            }

            // start transition
            var _this = this;
            this.on( 'transitionEnd', function() {
                _this.removeElem();
                return true; // bind once
            });
            this.hide();
        };

        Item.prototype.reveal = function() {
            delete this.isHidden;
            // remove display: none
            this.css({ display: '' });

            var options = this.layout.options;
            this.transition({
                from: options.hiddenStyle,
                to: options.visibleStyle,
                isCleaning: true
            });
        };

        Item.prototype.hide = function() {
            // set flag
            this.isHidden = true;
            // remove display: none
            this.css({ display: '' });

            var options = this.layout.options;
            this.transition({
                from: options.visibleStyle,
                to: options.hiddenStyle,
                // keep hidden stuff hidden
                isCleaning: true,
                onTransitionEnd: {
                    opacity: function() {
                        // check if still hidden
                        // during transition, item may have been un-hidden
                        if ( this.isHidden ) {
                            this.css({ display: 'none' });
                        }
                    }
                }
            });
        };

        Item.prototype.destroy = function() {
            this.css({
                position: '',
                left: '',
                right: '',
                top: '',
                bottom: '',
                transition: '',
                transform: ''
            });
        };

        return Item;

    }

// -------------------------- transport -------------------------- //

    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'outlayer/item',[
            'eventEmitter/EventEmitter',
            'get-size/get-size',
            'get-style-property/get-style-property'
        ],
            outlayerItemDefinition );
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = outlayerItemDefinition(
            require('wolfy87-eventemitter'),
            require('get-size'),
            require('desandro-get-style-property')
        );
    } else {
        // browser global
        window.Outlayer = {};
        window.Outlayer.Item = outlayerItemDefinition(
            window.EventEmitter,
            window.getSize,
            window.getStyleProperty
        );
    }

})( window );

/*!
 * Outlayer v1.3.0
 * the brains and guts of a layout library
 * MIT license
 */

( function( window ) {



// ----- vars ----- //

    var document = window.document;
    var console = window.console;
    var jQuery = window.jQuery;
    var noop = function() {};

// -------------------------- helpers -------------------------- //

// extend objects
    function extend( a, b ) {
        for ( var prop in b ) {
            a[ prop ] = b[ prop ];
        }
        return a;
    }


    var objToString = Object.prototype.toString;
    function isArray( obj ) {
        return objToString.call( obj ) === '[object Array]';
    }

// turn element or nodeList into an array
    function makeArray( obj ) {
        var ary = [];
        if ( isArray( obj ) ) {
            // use object if already an array
            ary = obj;
        } else if ( obj && typeof obj.length === 'number' ) {
            // convert nodeList to array
            for ( var i=0, len = obj.length; i < len; i++ ) {
                ary.push( obj[i] );
            }
        } else {
            // array of single index
            ary.push( obj );
        }
        return ary;
    }

// http://stackoverflow.com/a/384380/182183
    var isElement = ( typeof HTMLElement === 'function' || typeof HTMLElement === 'object' ) ?
        function isElementDOM2( obj ) {
            return obj instanceof HTMLElement;
        } :
        function isElementQuirky( obj ) {
            return obj && typeof obj === 'object' &&
                obj.nodeType === 1 && typeof obj.nodeName === 'string';
        };

// index of helper cause IE8
    var indexOf = Array.prototype.indexOf ? function( ary, obj ) {
        return ary.indexOf( obj );
    } : function( ary, obj ) {
        for ( var i=0, len = ary.length; i < len; i++ ) {
            if ( ary[i] === obj ) {
                return i;
            }
        }
        return -1;
    };

    function removeFrom( obj, ary ) {
        var index = indexOf( ary, obj );
        if ( index !== -1 ) {
            ary.splice( index, 1 );
        }
    }

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    function toDashed( str ) {
        return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
            return $1 + '-' + $2;
        }).toLowerCase();
    }


    function outlayerDefinition( eventie, docReady, EventEmitter, getSize, matchesSelector, Item ) {

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
        var GUID = 0;
// internal store of all Outlayer intances
        var instances = {};


        /**
         * @param {Element, String} element
         * @param {Object} options
         * @constructor
         */
        function Outlayer( element, options ) {
            // use element as selector string
            if ( typeof element === 'string' ) {
                element = document.querySelector( element );
            }

            // bail out if not proper element
            if ( !element || !isElement( element ) ) {
                if ( console ) {
                    console.error( 'Bad ' + this.constructor.namespace + ' element: ' + element );
                }
                return;
            }

            this.element = element;

            // options
            this.options = extend( {}, this.constructor.defaults );
            this.option( options );

            // add id for Outlayer.getFromElement
            var id = ++GUID;
            this.element.outlayerGUID = id; // expando
            instances[ id ] = this; // associate via id

            // kick it off
            this._create();

            if ( this.options.isInitLayout ) {
                this.layout();
            }
        }

// settings are for internal use only
        Outlayer.namespace = 'outlayer';
        Outlayer.Item = Item;

// default options
        Outlayer.defaults = {
            containerStyle: {
                position: 'relative'
            },
            isInitLayout: true,
            isOriginLeft: true,
            isOriginTop: true,
            isResizeBound: true,
            isResizingContainer: true,
            // item options
            transitionDuration: '0.4s',
            hiddenStyle: {
                opacity: 0,
                transform: 'scale(0.001)'
            },
            visibleStyle: {
                opacity: 1,
                transform: 'scale(1)'
            }
        };

// inherit EventEmitter
        extend( Outlayer.prototype, EventEmitter.prototype );

        /**
         * set options
         * @param {Object} opts
         */
        Outlayer.prototype.option = function( opts ) {
            extend( this.options, opts );
        };

        Outlayer.prototype._create = function() {
            // get items from children
            this.reloadItems();
            // elements that affect layout, but are not laid out
            this.stamps = [];
            this.stamp( this.options.stamp );
            // set container style
            extend( this.element.style, this.options.containerStyle );

            // bind resize method
            if ( this.options.isResizeBound ) {
                this.bindResize();
            }
        };

// goes through all children again and gets bricks in proper order
        Outlayer.prototype.reloadItems = function() {
            // collection of item elements
            this.items = this._itemize( this.element.children );
        };


        /**
         * turn elements into Outlayer.Items to be used in layout
         * @param {Array or NodeList or HTMLElement} elems
         * @returns {Array} items - collection of new Outlayer Items
         */
        Outlayer.prototype._itemize = function( elems ) {

            var itemElems = this._filterFindItemElements( elems );
            var Item = this.constructor.Item;

            // create new Outlayer Items for collection
            var items = [];
            for ( var i=0, len = itemElems.length; i < len; i++ ) {
                var elem = itemElems[i];
                var item = new Item( elem, this );
                items.push( item );
            }

            return items;
        };

        /**
         * get item elements to be used in layout
         * @param {Array or NodeList or HTMLElement} elems
         * @returns {Array} items - item elements
         */
        Outlayer.prototype._filterFindItemElements = function( elems ) {
            // make array of elems
            elems = makeArray( elems );
            var itemSelector = this.options.itemSelector;
            var itemElems = [];

            for ( var i=0, len = elems.length; i < len; i++ ) {
                var elem = elems[i];
                // check that elem is an actual element
                if ( !isElement( elem ) ) {
                    continue;
                }
                // filter & find items if we have an item selector
                if ( itemSelector ) {
                    // filter siblings
                    if ( matchesSelector( elem, itemSelector ) ) {
                        itemElems.push( elem );
                    }
                    // find children
                    var childElems = elem.querySelectorAll( itemSelector );
                    // concat childElems to filterFound array
                    for ( var j=0, jLen = childElems.length; j < jLen; j++ ) {
                        itemElems.push( childElems[j] );
                    }
                } else {
                    itemElems.push( elem );
                }
            }

            return itemElems;
        };

        /**
         * getter method for getting item elements
         * @returns {Array} elems - collection of item elements
         */
        Outlayer.prototype.getItemElements = function() {
            var elems = [];
            for ( var i=0, len = this.items.length; i < len; i++ ) {
                elems.push( this.items[i].element );
            }
            return elems;
        };

// ----- init & layout ----- //

        /**
         * lays out all items
         */
        Outlayer.prototype.layout = function() {
            this._resetLayout();
            this._manageStamps();

            // don't animate first layout
            var isInstant = this.options.isLayoutInstant !== undefined ?
                this.options.isLayoutInstant : !this._isLayoutInited;
            this.layoutItems( this.items, isInstant );

            // flag for initalized
            this._isLayoutInited = true;
        };

// _init is alias for layout
        Outlayer.prototype._init = Outlayer.prototype.layout;

        /**
         * logic before any new layout
         */
        Outlayer.prototype._resetLayout = function() {
            this.getSize();
        };


        Outlayer.prototype.getSize = function() {
            this.size = getSize( this.element );
        };

        /**
         * get measurement from option, for columnWidth, rowHeight, gutter
         * if option is String -> get element from selector string, & get size of element
         * if option is Element -> get size of element
         * else use option as a number
         *
         * @param {String} measurement
         * @param {String} size - width or height
         * @private
         */
        Outlayer.prototype._getMeasurement = function( measurement, size ) {
            var option = this.options[ measurement ];
            var elem;
            if ( !option ) {
                // default to 0
                this[ measurement ] = 0;
            } else {
                // use option as an element
                if ( typeof option === 'string' ) {
                    elem = this.element.querySelector( option );
                } else if ( isElement( option ) ) {
                    elem = option;
                }
                // use size of element, if element
                this[ measurement ] = elem ? getSize( elem )[ size ] : option;
            }
        };

        /**
         * layout a collection of item elements
         * @api public
         */
        Outlayer.prototype.layoutItems = function( items, isInstant ) {
            items = this._getItemsForLayout( items );

            this._layoutItems( items, isInstant );

            this._postLayout();
        };

        /**
         * get the items to be laid out
         * you may want to skip over some items
         * @param {Array} items
         * @returns {Array} items
         */
        Outlayer.prototype._getItemsForLayout = function( items ) {
            var layoutItems = [];
            for ( var i=0, len = items.length; i < len; i++ ) {
                var item = items[i];
                if ( !item.isIgnored ) {
                    layoutItems.push( item );
                }
            }
            return layoutItems;
        };

        /**
         * layout items
         * @param {Array} items
         * @param {Boolean} isInstant
         */
        Outlayer.prototype._layoutItems = function( items, isInstant ) {
            var _this = this;
            function onItemsLayout() {
                _this.emitEvent( 'layoutComplete', [ _this, items ] );
            }

            if ( !items || !items.length ) {
                // no items, emit event with empty array
                onItemsLayout();
                return;
            }

            // emit layoutComplete when done
            this._itemsOn( items, 'layout', onItemsLayout );

            var queue = [];

            for ( var i=0, len = items.length; i < len; i++ ) {
                var item = items[i];
                // get x/y object from method
                var position = this._getItemLayoutPosition( item );
                // enqueue
                position.item = item;
                position.isInstant = isInstant || item.isLayoutInstant;
                queue.push( position );
            }

            this._processLayoutQueue( queue );
        };

        /**
         * get item layout position
         * @param {Outlayer.Item} item
         * @returns {Object} x and y position
         */
        Outlayer.prototype._getItemLayoutPosition = function( /* item */ ) {
            return {
                x: 0,
                y: 0
            };
        };

        /**
         * iterate over array and position each item
         * Reason being - separating this logic prevents 'layout invalidation'
         * thx @paul_irish
         * @param {Array} queue
         */
        Outlayer.prototype._processLayoutQueue = function( queue ) {
            for ( var i=0, len = queue.length; i < len; i++ ) {
                var obj = queue[i];
                this._positionItem( obj.item, obj.x, obj.y, obj.isInstant );
            }
        };

        /**
         * Sets position of item in DOM
         * @param {Outlayer.Item} item
         * @param {Number} x - horizontal position
         * @param {Number} y - vertical position
         * @param {Boolean} isInstant - disables transitions
         */
        Outlayer.prototype._positionItem = function( item, x, y, isInstant ) {
            if ( isInstant ) {
                // if not transition, just set CSS
                item.goTo( x, y );
            } else {
                item.moveTo( x, y );
            }
        };

        /**
         * Any logic you want to do after each layout,
         * i.e. size the container
         */
        Outlayer.prototype._postLayout = function() {
            this.resizeContainer();
        };

        Outlayer.prototype.resizeContainer = function() {
            if ( !this.options.isResizingContainer ) {
                return;
            }
            var size = this._getContainerSize();
            if ( size ) {
                this._setContainerMeasure( size.width, true );
                this._setContainerMeasure( size.height, false );
            }
        };

        /**
         * Sets width or height of container if returned
         * @returns {Object} size
         *   @param {Number} width
         *   @param {Number} height
         */
        Outlayer.prototype._getContainerSize = noop;

        /**
         * @param {Number} measure - size of width or height
         * @param {Boolean} isWidth
         */
        Outlayer.prototype._setContainerMeasure = function( measure, isWidth ) {
            if ( measure === undefined ) {
                return;
            }

            var elemSize = this.size;
            // add padding and border width if border box
            if ( elemSize.isBorderBox ) {
                measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
                    elemSize.borderLeftWidth + elemSize.borderRightWidth :
                    elemSize.paddingBottom + elemSize.paddingTop +
                        elemSize.borderTopWidth + elemSize.borderBottomWidth;
            }

            measure = Math.max( measure, 0 );
            this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
        };

        /**
         * trigger a callback for a collection of items events
         * @param {Array} items - Outlayer.Items
         * @param {String} eventName
         * @param {Function} callback
         */
        Outlayer.prototype._itemsOn = function( items, eventName, callback ) {
            var doneCount = 0;
            var count = items.length;
            // event callback
            var _this = this;
            function tick() {
                doneCount++;
                if ( doneCount === count ) {
                    callback.call( _this );
                }
                return true; // bind once
            }
            // bind callback
            for ( var i=0, len = items.length; i < len; i++ ) {
                var item = items[i];
                item.on( eventName, tick );
            }
        };

// -------------------------- ignore & stamps -------------------------- //


        /**
         * keep item in collection, but do not lay it out
         * ignored items do not get skipped in layout
         * @param {Element} elem
         */
        Outlayer.prototype.ignore = function( elem ) {
            var item = this.getItem( elem );
            if ( item ) {
                item.isIgnored = true;
            }
        };

        /**
         * return item to layout collection
         * @param {Element} elem
         */
        Outlayer.prototype.unignore = function( elem ) {
            var item = this.getItem( elem );
            if ( item ) {
                delete item.isIgnored;
            }
        };

        /**
         * adds elements to stamps
         * @param {NodeList, Array, Element, or String} elems
         */
        Outlayer.prototype.stamp = function( elems ) {
            elems = this._find( elems );
            if ( !elems ) {
                return;
            }

            this.stamps = this.stamps.concat( elems );
            // ignore
            for ( var i=0, len = elems.length; i < len; i++ ) {
                var elem = elems[i];
                this.ignore( elem );
            }
        };

        /**
         * removes elements to stamps
         * @param {NodeList, Array, or Element} elems
         */
        Outlayer.prototype.unstamp = function( elems ) {
            elems = this._find( elems );
            if ( !elems ){
                return;
            }

            for ( var i=0, len = elems.length; i < len; i++ ) {
                var elem = elems[i];
                // filter out removed stamp elements
                removeFrom( elem, this.stamps );
                this.unignore( elem );
            }

        };

        /**
         * finds child elements
         * @param {NodeList, Array, Element, or String} elems
         * @returns {Array} elems
         */
        Outlayer.prototype._find = function( elems ) {
            if ( !elems ) {
                return;
            }
            // if string, use argument as selector string
            if ( typeof elems === 'string' ) {
                elems = this.element.querySelectorAll( elems );
            }
            elems = makeArray( elems );
            return elems;
        };

        Outlayer.prototype._manageStamps = function() {
            if ( !this.stamps || !this.stamps.length ) {
                return;
            }

            this._getBoundingRect();

            for ( var i=0, len = this.stamps.length; i < len; i++ ) {
                var stamp = this.stamps[i];
                this._manageStamp( stamp );
            }
        };

// update boundingLeft / Top
        Outlayer.prototype._getBoundingRect = function() {
            // get bounding rect for container element
            var boundingRect = this.element.getBoundingClientRect();
            var size = this.size;
            this._boundingRect = {
                left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
                top: boundingRect.top + size.paddingTop + size.borderTopWidth,
                right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
                bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
            };
        };

        /**
         * @param {Element} stamp
         **/
        Outlayer.prototype._manageStamp = noop;

        /**
         * get x/y position of element relative to container element
         * @param {Element} elem
         * @returns {Object} offset - has left, top, right, bottom
         */
        Outlayer.prototype._getElementOffset = function( elem ) {
            var boundingRect = elem.getBoundingClientRect();
            var thisRect = this._boundingRect;
            var size = getSize( elem );
            var offset = {
                left: boundingRect.left - thisRect.left - size.marginLeft,
                top: boundingRect.top - thisRect.top - size.marginTop,
                right: thisRect.right - boundingRect.right - size.marginRight,
                bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
            };
            return offset;
        };

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
        Outlayer.prototype.handleEvent = function( event ) {
            var method = 'on' + event.type;
            if ( this[ method ] ) {
                this[ method ]( event );
            }
        };

        /**
         * Bind layout to window resizing
         */
        Outlayer.prototype.bindResize = function() {
            // bind just one listener
            if ( this.isResizeBound ) {
                return;
            }
            eventie.bind( window, 'resize', this );
            this.isResizeBound = true;
        };

        /**
         * Unbind layout to window resizing
         */
        Outlayer.prototype.unbindResize = function() {
            if ( this.isResizeBound ) {
                eventie.unbind( window, 'resize', this );
            }
            this.isResizeBound = false;
        };

// original debounce by John Hann
// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/

// this fires every resize
        Outlayer.prototype.onresize = function() {
            if ( this.resizeTimeout ) {
                clearTimeout( this.resizeTimeout );
            }

            var _this = this;
            function delayed() {
                _this.resize();
                delete _this.resizeTimeout;
            }

            this.resizeTimeout = setTimeout( delayed, 100 );
        };

// debounced, layout on resize
        Outlayer.prototype.resize = function() {
            // don't trigger if size did not change
            // or if resize was unbound. See #9
            if ( !this.isResizeBound || !this.needsResizeLayout() ) {
                return;
            }

            this.layout();
        };

        /**
         * check if layout is needed post layout
         * @returns Boolean
         */
        Outlayer.prototype.needsResizeLayout = function() {
            var size = getSize( this.element );
            // check that this.size and size are there
            // IE8 triggers resize on body size change, so they might not be
            var hasSizes = this.size && size;
            return hasSizes && size.innerWidth !== this.size.innerWidth;
        };

// -------------------------- methods -------------------------- //

        /**
         * add items to Outlayer instance
         * @param {Array or NodeList or Element} elems
         * @returns {Array} items - Outlayer.Items
         **/
        Outlayer.prototype.addItems = function( elems ) {
            var items = this._itemize( elems );
            // add items to collection
            if ( items.length ) {
                this.items = this.items.concat( items );
            }
            return items;
        };

        /**
         * Layout newly-appended item elements
         * @param {Array or NodeList or Element} elems
         */
        Outlayer.prototype.appended = function( elems ) {
            var items = this.addItems( elems );
            if ( !items.length ) {
                return;
            }
            // layout and reveal just the new items
            this.layoutItems( items, true );
            this.reveal( items );
        };

        /**
         * Layout prepended elements
         * @param {Array or NodeList or Element} elems
         */
        Outlayer.prototype.prepended = function( elems ) {
            var items = this._itemize( elems );
            if ( !items.length ) {
                return;
            }
            // add items to beginning of collection
            var previousItems = this.items.slice(0);
            this.items = items.concat( previousItems );
            // start new layout
            this._resetLayout();
            this._manageStamps();
            // layout new stuff without transition
            this.layoutItems( items, true );
            this.reveal( items );
            // layout previous items
            this.layoutItems( previousItems );
        };

        /**
         * reveal a collection of items
         * @param {Array of Outlayer.Items} items
         */
        Outlayer.prototype.reveal = function( items ) {
            var len = items && items.length;
            if ( !len ) {
                return;
            }
            for ( var i=0; i < len; i++ ) {
                var item = items[i];
                item.reveal();
            }
        };

        /**
         * hide a collection of items
         * @param {Array of Outlayer.Items} items
         */
        Outlayer.prototype.hide = function( items ) {
            var len = items && items.length;
            if ( !len ) {
                return;
            }
            for ( var i=0; i < len; i++ ) {
                var item = items[i];
                item.hide();
            }
        };

        /**
         * get Outlayer.Item, given an Element
         * @param {Element} elem
         * @param {Function} callback
         * @returns {Outlayer.Item} item
         */
        Outlayer.prototype.getItem = function( elem ) {
            // loop through items to get the one that matches
            for ( var i=0, len = this.items.length; i < len; i++ ) {
                var item = this.items[i];
                if ( item.element === elem ) {
                    // return item
                    return item;
                }
            }
        };

        /**
         * get collection of Outlayer.Items, given Elements
         * @param {Array} elems
         * @returns {Array} items - Outlayer.Items
         */
        Outlayer.prototype.getItems = function( elems ) {
            if ( !elems || !elems.length ) {
                return;
            }
            var items = [];
            for ( var i=0, len = elems.length; i < len; i++ ) {
                var elem = elems[i];
                var item = this.getItem( elem );
                if ( item ) {
                    items.push( item );
                }
            }

            return items;
        };

        /**
         * remove element(s) from instance and DOM
         * @param {Array or NodeList or Element} elems
         */
        Outlayer.prototype.remove = function( elems ) {
            elems = makeArray( elems );

            var removeItems = this.getItems( elems );
            // bail if no items to remove
            if ( !removeItems || !removeItems.length ) {
                return;
            }

            this._itemsOn( removeItems, 'remove', function() {
                this.emitEvent( 'removeComplete', [ this, removeItems ] );
            });

            for ( var i=0, len = removeItems.length; i < len; i++ ) {
                var item = removeItems[i];
                item.remove();
                // remove item from collection
                removeFrom( item, this.items );
            }
        };

// ----- destroy ----- //

// remove and disable Outlayer instance
        Outlayer.prototype.destroy = function() {
            // clean up dynamic styles
            var style = this.element.style;
            style.height = '';
            style.position = '';
            style.width = '';
            // destroy items
            for ( var i=0, len = this.items.length; i < len; i++ ) {
                var item = this.items[i];
                item.destroy();
            }

            this.unbindResize();

            var id = this.element.outlayerGUID;
            delete instances[ id ]; // remove reference to instance by id
            delete this.element.outlayerGUID;
            // remove data for jQuery
            if ( jQuery ) {
                jQuery.removeData( this.element, this.constructor.namespace );
            }

        };

// -------------------------- data -------------------------- //

        /**
         * get Outlayer instance from element
         * @param {Element} elem
         * @returns {Outlayer}
         */
        Outlayer.data = function( elem ) {
            var id = elem && elem.outlayerGUID;
            return id && instances[ id ];
        };


// -------------------------- create Outlayer class -------------------------- //

        /**
         * create a layout class
         * @param {String} namespace
         */
        Outlayer.create = function( namespace, options ) {
            // sub-class Outlayer
            function Layout() {
                Outlayer.apply( this, arguments );
            }
            // inherit Outlayer prototype, use Object.create if there
            if ( Object.create ) {
                Layout.prototype = Object.create( Outlayer.prototype );
            } else {
                extend( Layout.prototype, Outlayer.prototype );
            }
            // set contructor, used for namespace and Item
            Layout.prototype.constructor = Layout;

            Layout.defaults = extend( {}, Outlayer.defaults );
            // apply new options
            extend( Layout.defaults, options );
            // keep prototype.settings for backwards compatibility (Packery v1.2.0)
            Layout.prototype.settings = {};

            Layout.namespace = namespace;

            Layout.data = Outlayer.data;

            // sub-class Item
            Layout.Item = function LayoutItem() {
                Item.apply( this, arguments );
            };

            Layout.Item.prototype = new Item();

            // -------------------------- declarative -------------------------- //

            /**
             * allow user to initialize Outlayer via .js-namespace class
             * options are parsed from data-namespace-option attribute
             */
            docReady( function() {
                var dashedNamespace = toDashed( namespace );
                var elems = document.querySelectorAll( '.js-' + dashedNamespace );
                var dataAttr = 'data-' + dashedNamespace + '-options';

                for ( var i=0, len = elems.length; i < len; i++ ) {
                    var elem = elems[i];
                    var attr = elem.getAttribute( dataAttr );
                    var options;
                    try {
                        options = attr && JSON.parse( attr );
                    } catch ( error ) {
                        // log error, do not initialize
                        if ( console ) {
                            console.error( 'Error parsing ' + dataAttr + ' on ' +
                                elem.nodeName.toLowerCase() + ( elem.id ? '#' + elem.id : '' ) + ': ' +
                                error );
                        }
                        continue;
                    }
                    // initialize
                    var instance = new Layout( elem, options );
                    // make available via $().data('layoutname')
                    if ( jQuery ) {
                        jQuery.data( elem, namespace, instance );
                    }
                }
            });

            // -------------------------- jQuery bridge -------------------------- //

            // make into jQuery plugin
            if ( jQuery && jQuery.bridget ) {
                jQuery.bridget( namespace, Layout );
            }

            return Layout;
        };

// ----- fin ----- //

// back in global
        Outlayer.Item = Item;

        return Outlayer;

    }

// -------------------------- transport -------------------------- //

    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( 'outlayer/outlayer',[
            'eventie/eventie',
            'doc-ready/doc-ready',
            'eventEmitter/EventEmitter',
            'get-size/get-size',
            'matches-selector/matches-selector',
            './item'
        ],
            outlayerDefinition );
    } else if ( typeof exports === 'object' ) {
        // CommonJS
        module.exports = outlayerDefinition(
            require('eventie'),
            require('doc-ready'),
            require('wolfy87-eventemitter'),
            require('get-size'),
            require('desandro-matches-selector'),
            require('./item')
        );
    } else {
        // browser global
        window.Outlayer = outlayerDefinition(
            window.eventie,
            window.docReady,
            window.EventEmitter,
            window.getSize,
            window.matchesSelector,
            window.Outlayer.Item
        );
    }

})( window );

/*!
 * Masonry v3.2.2
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window ) {



// -------------------------- helpers -------------------------- //

    var indexOf = Array.prototype.indexOf ?
        function( items, value ) {
            return items.indexOf( value );
        } :
        function ( items, value ) {
            for ( var i=0, len = items.length; i < len; i++ ) {
                var item = items[i];
                if ( item === value ) {
                    return i;
                }
            }
            return -1;
        };

// -------------------------- masonryDefinition -------------------------- //

// used for AMD definition and requires
    function masonryDefinition( Outlayer, getSize ) {
        // create an Outlayer layout class
        var Masonry = Outlayer.create('masonry');

        Masonry.prototype._resetLayout = function() {
            this.getSize();
            this._getMeasurement( 'columnWidth', 'outerWidth' );
            this._getMeasurement( 'gutter', 'outerWidth' );
            this.measureColumns();

            // reset column Y
            var i = this.cols;
            this.colYs = [];
            while (i--) {
                this.colYs.push( 0 );
            }

            this.maxY = 0;
        };

        Masonry.prototype.measureColumns = function() {
            this.getContainerWidth();
            // if columnWidth is 0, default to outerWidth of first item
            if ( !this.columnWidth ) {
                var firstItem = this.items[0];
                var firstItemElem = firstItem && firstItem.element;
                // columnWidth fall back to item of first element
                this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
                    // if first elem has no width, default to size of container
                    this.containerWidth;
            }

            this.columnWidth += this.gutter;

            this.cols = Math.floor( ( this.containerWidth + this.gutter ) / this.columnWidth );
            this.cols = Math.max( this.cols, 1 );
        };

        Masonry.prototype.getContainerWidth = function() {
            // container is parent if fit width
            var container = this.options.isFitWidth ? this.element.parentNode : this.element;
            // check that this.size and size are there
            // IE8 triggers resize on body size change, so they might not be
            var size = getSize( container );
            this.containerWidth = size && size.innerWidth;
        };

        Masonry.prototype._getItemLayoutPosition = function( item ) {
            item.getSize();
            // how many columns does this brick span
            var remainder = item.size.outerWidth % this.columnWidth;
            var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
            // round if off by 1 pixel, otherwise use ceil
            var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
            colSpan = Math.min( colSpan, this.cols );

            var colGroup = this._getColGroup( colSpan );
            // get the minimum Y value from the columns
            var minimumY = Math.min.apply( Math, colGroup );
            var shortColIndex = indexOf( colGroup, minimumY );

            // position the brick
            var position = {
                x: this.columnWidth * shortColIndex,
                y: minimumY
            };

            // apply setHeight to necessary columns
            var setHeight = minimumY + item.size.outerHeight;
            var setSpan = this.cols + 1 - colGroup.length;
            for ( var i = 0; i < setSpan; i++ ) {
                this.colYs[ shortColIndex + i ] = setHeight;
            }

            return position;
        };

        /**
         * @param {Number} colSpan - number of columns the element spans
         * @returns {Array} colGroup
         */
        Masonry.prototype._getColGroup = function( colSpan ) {
            if ( colSpan < 2 ) {
                // if brick spans only one column, use all the column Ys
                return this.colYs;
            }

            var colGroup = [];
            // how many different places could this brick fit horizontally
            var groupCount = this.cols + 1 - colSpan;
            // for each group potential horizontal position
            for ( var i = 0; i < groupCount; i++ ) {
                // make an array of colY values for that one group
                var groupColYs = this.colYs.slice( i, i + colSpan );
                // and get the max value of the array
                colGroup[i] = Math.max.apply( Math, groupColYs );
            }
            return colGroup;
        };

        Masonry.prototype._manageStamp = function( stamp ) {
            var stampSize = getSize( stamp );
            var offset = this._getElementOffset( stamp );
            // get the columns that this stamp affects
            var firstX = this.options.isOriginLeft ? offset.left : offset.right;
            var lastX = firstX + stampSize.outerWidth;
            var firstCol = Math.floor( firstX / this.columnWidth );
            firstCol = Math.max( 0, firstCol );
            var lastCol = Math.floor( lastX / this.columnWidth );
            // lastCol should not go over if multiple of columnWidth #425
            lastCol -= lastX % this.columnWidth ? 0 : 1;
            lastCol = Math.min( this.cols - 1, lastCol );
            // set colYs to bottom of the stamp
            var stampMaxY = ( this.options.isOriginTop ? offset.top : offset.bottom ) +
                stampSize.outerHeight;
            for ( var i = firstCol; i <= lastCol; i++ ) {
                this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
            }
        };

        Masonry.prototype._getContainerSize = function() {
            this.maxY = Math.max.apply( Math, this.colYs );
            var size = {
                height: this.maxY
            };

            if ( this.options.isFitWidth ) {
                size.width = this._getContainerFitWidth();
            }

            return size;
        };

        Masonry.prototype._getContainerFitWidth = function() {
            var unusedCols = 0;
            // count unused columns
            var i = this.cols;
            while ( --i ) {
                if ( this.colYs[i] !== 0 ) {
                    break;
                }
                unusedCols++;
            }
            // fit container to columns that have been used
            return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
        };

        Masonry.prototype.needsResizeLayout = function() {
            var previousWidth = this.containerWidth;
            this.getContainerWidth();
            return previousWidth !== this.containerWidth;
        };

        return Masonry;
    }

// -------------------------- transport -------------------------- //

    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
            'outlayer/outlayer',
            'get-size/get-size'
        ],
            masonryDefinition );
    } else if ( typeof exports === 'object' ) {
        // CommonJS
        module.exports = masonryDefinition(
            require('outlayer'),
            require('get-size')
        );
    } else {
        // browser global
        window.Masonry = masonryDefinition(
            window.Outlayer,
            window.getSize
        );
    }

})( window );

